export enum ErrorCodes {
  serverError = 500,
  notModified = 304,
  forbidden = 403,
  notFound = 404,
  conflict = 409,
  validation = 422,
}
